module.exports = __webpack_public_path__ + "static/img/svg.617b5f96.png";